import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import EditDetails from './EditDetails';
import PanelDetails from './PanelDetails';
import styles from './styles';

const CompanyBuyer = ({ classes, intl, locale, isEditFlow, buyer, onChangeHandler }) => {
  return isEditFlow ? (
    <EditDetails {...{ classes, intl, buyer, onChangeHandler }} />
  ) : (
    <PanelDetails {...{ classes, locale, buyer }} />
  );
};

CompanyBuyer.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  isEditFlow: PropTypes.bool.isRequired,
  buyer: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func,
};

CompanyBuyer.defaultProps = {
  onChangeHandler: () => {},
};

export default withStyles(styles)(CompanyBuyer);
